import { useGetHotels } from 'api-hooks/hotel';
import { NavigationRoutes } from 'common/constants';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useGetListParamsValue from 'hooks/use-get-list-params-value';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import UniskaiListTemplate from 'templates/list/uniskai-list-template';

export default function HotelList() {
  const { t } = useTranslation();
  const { queryPage } = useGetListParamsValue();
  const [page, setPage] = React.useState(queryPage);

  const permission = useGetCrudPermission('hotels');

  const _columns = React.useMemo(
    () => [
      {
        header: t('common:area'),
        accessorKey: 'area',
        minSize: 150,
        sortName: 'area',
      },
      {
        header: t('common:hotel'),
        accessorKey: 'name',
        minSize: 250,
        sortName: 'name',
      },
      {
        header: [t('common:city'), t('common:country')].join(', '),
        accessorKey: 'cityCountry',
        minSize: 150,
        sortName: 'city_country',
      },
      {
        header: t('common:address'),
        accessorKey: 'address',
        minSize: 250,
        sortName: 'address',
      },
      {
        header: t('common:email'),
        accessorKey: 'email',
        minSize: 180,
      },
      {
        header: t('cruise:tel_phone'),
        accessorKey: 'phone',
        minSize: 180,
      },
      {
        header: t('cruise:cellphone_number'),
        accessorKey: 'phone_2',
        minSize: 180,
      },
    ],
    [t],
  );

  return (
    <UniskaiListTemplate
      title={t(`pathname:${NavigationRoutes.HotelsList}`)}
      columns={_columns}
      page={page}
      setPage={setPage}
      useQuery={useGetHotels}
      queryInput={{
        params: {
          page,
        },
      }}
      tableName={NavigationRoutes.HotelsList}
      addNavigation={NavigationRoutes.HotelsCreate}
      rowLink={
        permission?.view
          ? (row) => ({
              pathname: NavigationRoutes.HotelsView,
              query: { id: row.original.id },
            })
          : undefined
      }
    />
  );
}
